import { render } from "./view-and-compare-your-shortlisted-vehicles-component.vue?vue&type=template&id=0e21912a"
import script from "./view-and-compare-your-shortlisted-vehicles-component.vue?vue&type=script&lang=js"
export * from "./view-and-compare-your-shortlisted-vehicles-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__